
import { TableRow, TableHead,  SxProps, Theme } from "@mui/material";
import { HeaderCell } from "./HeaderCell";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../../../contexts/user-context/UserContext";

export type TankHeaderRowProps = {
    dualPhase: boolean;
    hasOil: boolean;
    hasWater: boolean;
    sx?: SxProps<Theme>
};

export function TankHeaderRow({
    dualPhase,
    hasOil,
    hasWater,
    sx
}: TankHeaderRowProps) {

    const [userState] = useUserContext();

    const { t } = useTranslation();


    return (
    <TableHead sx={{...sx}}>
        <TableRow>

            <HeaderCell text={t('tankRelationships.tankName')} />
            <HeaderCell text={t('tankRelationships.tankNumber')} />
            <HeaderCell text={userState.userSettings?.tankLevelInches ? `${t('tankRelationships.topLevel')} (Inches)` : t('tankRelationships.topLevel')} />
            {dualPhase &&
                <HeaderCell text={userState.userSettings?.tankLevelInches ? `${t('tankRelationships.interfaceLevel')} (Inches)` : t('tankRelationships.interfaceLevel')} />
            }
            <HeaderCell text={t('tankRelationships.capacity')} />                                
            <HeaderCell text={t('tankRelationships.capacityFilled')}  hideDivider={true}/>

            {hasOil &&
                <HeaderCell text={t('tankRelationships.dailyOilProduction')} />
            }
            {hasWater &&
                <HeaderCell text={t('tankRelationships.dailyWaterProduction')} />
            }


        </TableRow>
    </TableHead>
    )

    
}
